import { useEffect, useRef } from 'react';

const useCustomWindowOpen = ({ isEnabled = false }) => {
  const nativeRef = useRef(null);

  useEffect(() => {
    if (!isEnabled || typeof window === 'undefined') {
      return undefined;
    }

    if (nativeRef.current === null) {
      nativeRef.current = window.open;
    }

    if (window.open !== nativeRef.current) {
      return undefined;
    }

    const wrappedOpen = (...args) => {
      const newWin = nativeRef.current.apply(window, args);

      if (newWin && window.analyticsWindow) {
        newWin.onload = () => {
          newWin.analyticsWindow = window.analyticsWindow;
        };
      }

      return newWin;
    };

    window.open = wrappedOpen;

    return () => {
      window.open = nativeRef.current;
    };
  }, [isEnabled]);
};

export default useCustomWindowOpen;
